import styled from "@emotion/styled";
interface DecreaseTextProps {
    width?: CSSValue;
    $wrap?: boolean;
}

export const DecreaseText = styled.div<DecreaseTextProps>`
    overflow: hidden;
    width: ${({ width }) => width ?? "auto"};
    text-overflow: ellipsis;
    white-space: ${({ $wrap }) => ($wrap ? "wrap" : "nowrap")};
`;
